(() => {
  if (customElements.get('tfb-bike-compare')) return;
  class BikeCompare extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.labels = this.querySelector('[data-compare-translations]').dataset;
      this.logos = JSON.parse(this.querySelector('[data-compare-logos]')?.textContent || '{}');
      const initial = JSON.parse(this.querySelector('[data-compare-initial]').textContent);
      this.current = initial.current;
      this.catalog = new Map([...initial.catalog, ...JSON.parse(this.querySelector('[data-compare-extra]')?.textContent || '[]')].map(p => [p.id, p]));
      const suggestions = initial.suggestions.length ? initial.suggestions : initial.catalog.slice().sort((a,b) => {
        const sameA = this.model(a) === this.model(this.current) ? 2 : this.brandName(a) === this.brandName(this.current) ? 0 : 1;
        const sameB = this.model(b) === this.model(this.current) ? 2 : this.brandName(b) === this.brandName(this.current) ? 0 : 1;
        return sameA - sameB || Math.abs(a.price-this.current.price)-Math.abs(b.price-this.current.price);
      });
      this.selected = [this.current];
      suggestions.forEach(p => { if (this.selected.length < 3 && !this.selected.some(s=>s.id===p.id || (!initial.suggestions.length && this.model(s)===this.model(p)))) this.selected.push(p); });
      this.tableHost = this.querySelector('[data-compare-table]');
      this.status = this.querySelector('[data-compare-status]');
      this.dialog = this.querySelector('dialog');
      this.search = this.querySelector('[data-compare-search]');
      this.brand = '';
      this.querySelector('[data-compare-close]').addEventListener('click',()=>this.dialog.close());
      this.dialog.addEventListener('click',e=> { if(e.target===this.dialog) {const r=this.dialog.getBoundingClientRect(); if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();} });
      this.dialog.addEventListener('close',()=>{ if(this.opener?.isConnected)this.opener.focus(); else this.tableHost.focus(); });
      this.search.addEventListener('input',()=>{this.renderBrands();this.renderResults();});
      this.backButton=this.button('← '+this.labels.all,()=>{this.brand='';this.search.value='';this.renderBrands();this.renderResults();this.search.focus();},'tfb-compare__back');
      this.querySelector('.tfb-compare__filters').prepend(this.backButton);
      this.renderTable();
      this.renderBrands();
    }
    model(p) { return p.title.toLowerCase().replace(/combi[ -]deal!?\s*\|?/g,'').trim().split(/\s[-–]\s/)[0]; }
    brandName(p) {
      const title=p.title.toLowerCase();
      for(const [pattern,label] of [[/ouxi/,'OUXI'],[/qm[ -]?wheels|v20 limited/,'QM Wheels'],[/engwe/,'ENGWE'],[/a[ -]?spadz/,'A-Spadz'],[/qreate/,'Qreate'],[/pixar/,'Pixar'],[/fiido/,'Fiido'],[/jobobike/,'JOBOBIKE'],[/\b7[ -]?go\b/,'7GO'],[/\bstoer\b/,'STOER'],[/\btomos\b/,'TOMOS'],[/\bknaap\b/,'KNAAP'],[/\bv20\b/,'V20']])if(pattern.test(title))return label;
      return Object.keys(this.logos).find(name=>name.toLocaleLowerCase()===p.vendor?.trim().toLocaleLowerCase()) || p.vendor;
    }
    el(tag, cls, text) {
      const n=document.createElement(tag); if(cls)n.className=cls; if(text!=null)n.textContent=text; return n;
    }
    button(text, fn, cls='') {
      const b=this.el('button',cls,text); b.type='button'; b.addEventListener('click',fn); return b;
    }
    image(p, cls) {
      const wrap=this.el('div',cls);
      if(p.image){const img=this.el('img');img.src=p.image;img.alt=p.title;img.width=320;img.height=240;img.loading='lazy';wrap.append(img);}
      return wrap;
    }
    price(p) {
      const box=this.el('div','tfb-compare__price'+(p.compareText?' is-sale':''));
      box.append(this.el('strong','',p.priceText));
      if(p.compareText)box.append(this.el('s','',p.compareText));return box;
    }
    renderTable() {
      const table=this.el('table','tfb-compare__table');
      const caption=this.el('caption','sr-only',this.querySelector('h2').textContent); table.append(caption);
      const head=this.el('thead');const row=this.el('tr');
      this.selected.forEach((p,i)=>{
        const cell=this.el('th','tfb-compare__product');cell.scope='col';
        const top=this.el('div','tfb-compare__product-top');
        if(i===0)top.append(this.el('span','tfb-compare__current',this.labels.current));
        else top.append(this.button('×',()=>this.remove(p.id),'tfb-compare__remove'));
        if(i>0)top.firstChild.setAttribute('aria-label',`${this.labels.remove}: ${p.title}`);
        cell.append(top,this.image(p,'tfb-compare__image'),this.el('h3','tfb-compare__name',p.title),this.price(p));
        const link=this.el('a','tfb-compare__options',this.labels.options);link.href=p.url;cell.append(link);
        if(!p.available)cell.append(this.el('p','tfb-compare__unavailable',this.labels.unavailable));
        row.append(cell);
      });
      if(this.selected.length<4){
        const cell=this.el('th','tfb-compare__add-cell');cell.scope='col';
        const button=this.button('',e=>this.open(e.currentTarget),'tfb-compare__add');
        button.append(this.el('span','tfb-compare__plus','+'),this.el('span','',this.labels.choose));
        cell.append(button);row.append(cell);
      }
      head.append(row);table.append(head);
      const body=this.el('tbody');
      [this.labels.range,this.labels.motor,this.labels.battery,this.labels.charging,this.labels.speed].forEach((label,index)=>{
        const r=this.el('tr');
        this.selected.forEach(p=>{const cell=this.el('td');cell.append(this.el('span','tfb-compare__spec-label',label),this.el('span','tfb-compare__spec-value',p.specs[index]||this.labels.missing));r.append(cell);});
        if(this.selected.length<4)r.append(this.el('td','tfb-compare__empty-cell'));
        body.append(r);
      });
      table.append(body);this.tableHost.replaceChildren(table);
    }
    remove(id) {
      this.selected=this.selected.filter((p,i)=>i===0||p.id!==id);this.renderTable();this.renderResults();this.status.textContent=this.labels.removed;this.tableHost.focus();
    }
    open(button) {
      this.opener=button;this.dialog.showModal();this.renderBrands();this.renderResults();this.search.focus();
      if(!this.loaded&&!this.loading)this.loadCatalog();
    }
    renderBrands() {
      const host=this.querySelector('[data-compare-brands]');host.replaceChildren();
      const filtering=!!this.brand||!!this.search.value.trim();
      host.hidden=filtering;this.backButton.hidden=!filtering;
      if(filtering)return;
      const vendors=Array.from(new Set(Array.from(this.catalog.values()).map(p=>this.brandName(p)).filter(Boolean))).sort();
      vendors.forEach(v=>{
        const b=this.button('',()=>{this.brand=v;this.renderBrands();this.renderResults();},'tfb-compare__brand');
        b.setAttribute('aria-label',v);b.setAttribute('aria-pressed','false');
        if(this.logos[v]){const img=this.el('img');img.src=this.logos[v];img.alt=v;img.loading='lazy';img.width=140;img.height=54;
          img.addEventListener('error',()=>{b.replaceChildren(this.el('span','',v));},{once:true});b.append(img);
        }else b.append(this.el('span','',v));
        host.append(b);
      });
    }
    renderResults() {
      const host=this.querySelector('[data-compare-results]');host.replaceChildren();
      const q=this.search.value.trim().toLocaleLowerCase();
      host.hidden=!this.brand&&!q;
      if(host.hidden)return;
      const matches=Array.from(this.catalog.values()).filter(p=>(!this.brand||this.brandName(p)===this.brand)&&(`${p.title} ${this.brandName(p)}`.toLocaleLowerCase().includes(q)));
      if(!matches.length)host.append(this.el('p','',this.loading?this.labels.loading:this.labels.empty));
      matches.forEach(p=>{
        const selected=this.selected.some(s=>s.id===p.id);
        const b=this.button('',()=>this.add(p),'tfb-compare__result');
        b.disabled=selected||this.selected.length>=4;
        const content=this.el('span','tfb-compare__result-info');content.append(this.el('strong','',p.title),this.price(p),this.el('span','tfb-compare__result-action',selected?this.labels.selected:''));
        b.append(this.image(p,'tfb-compare__result-image'),content);host.append(b);
      });
    }
    add(p) {
      if(this.selected.length>=4||this.selected.some(s=>s.id===p.id))return;
      this.selected.push(p);this.renderTable();this.status.textContent=`${p.title} ${this.labels.added}`;this.dialog.close();
    }
    async loadCatalog() {
      this.loading=true;
      const status=this.querySelector('[data-compare-loading]');status.textContent=this.labels.loading;
      try {
        const sources=JSON.parse(this.querySelector('[data-compare-collections]')?.textContent || '[]');
        if(!sources.length&&this.dataset.collectionUrl)sources.push(this.dataset.collectionUrl);
        if(!sources.length)throw new Error('Missing collection');
        for(const source of new Set(sources)){
          let next=new URL(source,location.origin);const visited=new Set();
          while(next){
            next.searchParams.set('section_id','tfb-compare-catalog');
            if(next.origin!==location.origin||visited.has(next.href))throw new Error('Invalid pagination');
            visited.add(next.href);
            const controller=new AbortController();const timer=setTimeout(()=>controller.abort(),15000);
            let response;let markup;
            try{response=await fetch(next,{signal:controller.signal});markup=await response.text();}finally{clearTimeout(timer);}
            if(!response.ok)throw new Error('Catalog unavailable');
            const html=new DOMParser().parseFromString(markup,'text/html');
            const data=JSON.parse(html.querySelector('[data-tfb-catalog]').textContent);
            data.products.forEach(p=>this.catalog.set(p.id,p));
            this.renderBrands();this.renderResults();
            next=data.next?new URL(data.next,location.origin):null;
          }
        }
        this.loaded=true;status.textContent='';
      } catch(error) {
        status.replaceChildren(this.el('span','',this.labels.error+' '),this.button(this.labels.retry,()=>{if(!this.loading)this.loadCatalog();},'tfb-compare__retry'));
      } finally {this.loading=false;this.renderResults();}
    }
  }
  customElements.define('tfb-bike-compare',BikeCompare);
})();
